import { VENDOR_ADDRESSES_ACTIONS } from './vendorAddresses.types'

/**
 * @param {Object.<string, import('./vendorAddresses.types').VendorAddress>} payload
 * @returns {Object}
 */
export const setVendorAddressesAction = payload => ({
  type: VENDOR_ADDRESSES_ACTIONS.SET_VENDOR_ADDRESSES,
  payload
})

/**
 * @param {import('./vendorAddresses.types').VendorAddress} payload
 * @returns {Object}
 */
export const setVendorAddressAction = payload => ({
  type: VENDOR_ADDRESSES_ACTIONS.SET_VENDOR_ADDRESS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setVendorAddressesStatusAction = payload => ({
  type: VENDOR_ADDRESSES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setVendorAddressesErrorsAction = payload => ({
  type: VENDOR_ADDRESSES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearVendorAddressesErrorsAction = () => ({
  type: VENDOR_ADDRESSES_ACTIONS.CLEAR_ERRORS
})
